import React from "react";
import { Button } from "react-bootstrap";
import { setStepIndex, startTour } from "../redux/globalJoyrideSlice";

/* 🔹 Reusable bilingual content */
export const JoyrideContent = ({ en, hi }) => (
    <div>
        <div style={{ fontWeight: 500 }}>{en}</div>
        <div
            style={{ fontWeight: 500, marginTop: "4px" }}
        >
            {hi}
        </div>
    </div>
);

/* 🔹 SUBJECT STEPS */
export const subjectSteps = ({
    setOpenForTour,
    setShowModal,
    setFormData,
    setEditingSubject,
    navigate,
    stopTour,
    dispatch,
}) => [
        {
            target: "#add-subject-btn",
            content: (
                <JoyrideContent
                    en="Click here to add a new subject."
                    hi="नया विषय जोड़ने के लिए यहाँ क्लिक करें।"
                />
            ),
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: "#single-subject-tab",
            content: (
                <JoyrideContent
                    en="Choose the type of subject."
                    hi="एक या एक से अधिक विषय जोड़ने का विकल्प चुनें।"
                />
            ),
            placement: "left",
            spotlightClicks: true,
            hideFooter: true,
            disableScrolling: true,
        },
        {
            target: "#subject-name-input",
            content: (
                <JoyrideContent
                    en="Enter the subject/subjects name here."
                    hi="यहाँ विषय/विषयों के नाम लिखें"
                />
            ),
            placement: "left",
            spotlightClicks: true,
            disableScrolling: true,
            isFixed: true,
            showNext: true,
        },
        {
            target: "#create-subject-btn",
            content: (
                <JoyrideContent
                    en="Click here to save the subject."
                    hi="विषय को सेव के लिए यहाँ क्लिक करें।"
                />
            ),
            placement: "bottom",
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: "#joyride-confirm-anchor",
            placement: "center",
            disableOverlayClose: true,
            disableScrolling: true,
            hideFooter: true,
            content: (
                <div style={{ textAlign: "center" }}>
                    <h6>Subject created successfully</h6>
                    <p style={{ fontSize: "13px", color: "#6b7280" }}>
                        विषय सफलतापूर्वक बनाया गया
                    </p>
                    <p>Do you want to add another subject?</p>
                    <p style={{ fontSize: "13px", color: "#6b7280" }}>
                        क्या आप एक और विषय जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-2">
                        <Button
                            size="sm"
                            variant="primary"
                            onClick={() => {
                                stopTour();

                                setEditingSubject(null);
                                setFormData({ subject_name: "" });
                                setShowModal(true);

                                setTimeout(() => {
                                    // 1️⃣ Start tour first (this resets to 0)
                                    dispatch(startTour({
                                        name: "subject",
                                        steps: subjectSteps({
                                            dispatch,
                                            setShowModal,
                                            setFormData,
                                            setEditingSubject,
                                            navigate,
                                            stopTour: () => dispatch(stopTour()),
                                        }),
                                    }));
                                    dispatch(setStepIndex(1));   // ✅ NOW IT WORKS
                                }, 400);
                            }}
                        >
                            Yes / हाँ
                        </Button>
                        <Button
                            size="sm"
                            variant="secondary"
                            onClick={() => {
                                //setRunTour(false);
                                dispatch(setStepIndex(0));
                                navigate("/timetable/teachers", { state: { startTour: true } });

                            }}
                        >
                            No / नहीं
                        </Button>
                    </div>
                </div>
            ),
        },
    ];

export const teacherSteps = ({
    setRunTour,
    setShowModal,
    initializeForm,
    navigate,
    stopTour,
    dispatch,
}) => [
        {
            target: ".add-teacher-step",
            content: (
                <JoyrideContent
                    en="Click here to add teacher ."
                    hi="शिक्षक जोड़ने के लिए यहाँ क्लिक करें।"
                />
            ),
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: true,
        },
        {
            target: ".teacher-name-step",
            content: (
                <JoyrideContent
                    en="Enter the teacher's name."
                    hi="शिक्षक का नाम भरें।"
                />
            ),
            placement: "bottom",
            spotlightClicks: true,
            showNext: true,
        },
        {
            target: ".teacher-qualification-step",
            content: (
                <JoyrideContent
                    en="Enter the qualification."
                    hi="शिक्षक की योग्यता भरें"
                />
            ),
            placement: "bottom",
            spotlightClicks: true,
            showNext: true,
        },
        {
            target: ".subject-step",
            content: (
                <JoyrideContent
                    en="Select the subjects to be taught ."
                    hi="पढ़ाए जाने वाले विषयों का चयन करें।"
                />
            ),
            placement: "top",
            spotlightClicks: true,
            hideFooter: true,
            isFixed: false,
        },
        {
            target: ".class-step",
            content: (
                <JoyrideContent
                    en="Select class/classes for these subjects."
                    hi="इन विषयों के लिए कक्षाओं का चयन करें ।"
                />
            ),
            placement: "left",
            spotlightClicks: true,
            hideFooter: true,
            isFixed: false,
            showNext: true,
        },
        {
            target: "body", // center popup
            placement: "center",
            content: (
                <div style={{ textAlign: "center", minWidth: 280 }}>
                    <h6 style={{ marginBottom: 10 }}>
                        Do you want to add another subject for this teacher?
                    </h6>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <Button
                            size="sm"
                            variant="success"
                            onClick={() => {
                                // YES → go to subject-step
                                dispatch(setStepIndex(3)); // index of `.subject-step`
                            }}
                        >
                            Yes
                        </Button>

                        <Button
                            size="sm"
                            variant="secondary"
                            onClick={() => {
                                // NO → go to create-teacher-step
                                dispatch(setStepIndex(6)); // index of `.create-teacher-step`
                            }}
                        >
                            No
                        </Button>
                    </div>
                </div>
            ),
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: false,
        },
        {
            target: ".create-teacher-step",
            content: (
                <JoyrideContent
                    en="click here to submit and save ."
                    hi="सबमिट और सेव करने के लिए यहां क्लिक करें।"
                />
            ),
            placement: "top",
            spotlightClicks: true,
            hideFooter: true,
        },
        {
            target: ".teacher-confirm-anchor",
            placement: "center",
            disableOverlayClose: true,
            disableScrolling: true,
            hideFooter: true,
            content: (
                <div style={{ textAlign: "center" }}>
                    <h6>Teacher created successfully</h6>
                    <p style={{ fontSize: "13px", color: "#6b7280" }}>
                        शिक्षक सफलतापूर्वक बनाया गया।
                    </p>

                    <p>Do you want to add another teacher?</p>
                    <p style={{ fontSize: "13px", color: "#6b7280" }}>
                        क्या आप एक और शिक्षक जोड़ना चाहते हैं?
                    </p>

                    <div className="d-flex justify-content-center gap-2">
                        <Button
                            size="sm"
                            variant="primary"
                            onClick={() => {
                                stopTour();
                                setShowModal(true);
                                initializeForm();

                                requestAnimationFrame(() => {
                                    requestAnimationFrame(() => {
                                        const input = document.querySelector(".teacher-name-step");

                                        if (input) {
                                            input.scrollIntoView({
                                                behavior: "smooth",
                                                block: "center",
                                            });
                                            input.focus();
                                        }

                                        setTimeout(() => {
                                            // 1️⃣ Start tour first (this resets to 0)
                                            dispatch(startTour({
                                                name: "teacher",
                                                steps: teacherSteps({
                                                    dispatch,
                                                    setShowModal,
                                                    initializeForm,
                                                    navigate,
                                                    stopTour: () => dispatch(stopTour()),
                                                }),
                                            }));
                                            dispatch(setStepIndex(1));   // ✅ NOW IT WORKS
                                        }, 400);
                                    });
                                });
                            }}
                        >
                            Yes / हाँ
                        </Button>

                        <Button
                            size="sm"
                            variant="secondary"
                            onClick={() => {
                                // setRunTour(false);
                                dispatch(setStepIndex(0));
                                navigate("/timetable/classes", {
                                    state: { startClassTour: true },
                                });
                            }}
                        >
                            No / नहीं
                        </Button>
                    </div>
                </div>
            ),
        },
    ];

export const classSteps = ({
    setRunClassTour,
    setClassStepIndex,
    setActiveTab,
    navigate,
    dispatch
}) => [
        {
            target: ".class-list-step",
            content: (
                <JoyrideContent
                    en="Classes entered in Master Data are listed here."
                    hi="मास्टर डेटा में दर्ज की गई कक्षाएं यहाँ सूचीबद्ध हैं।"
                />
            ),
            placement: "bottom",        // ONLY one placement
            disableBeacon: true,
            disableScrolling: true,
            //showNext: true,
            floaterProps: {
                disableFlip: true,     // no auto reposition
                offset: 18,            // 🔥 OUTSIDE purple bar
            },
        },
        {
            target: ".class-active-step",
            placement: "bottom",
            content: (
                <JoyrideContent
                    en="Activate the class."
                    hi="कक्षा को एक्टिव करें।"
                />
            ),
        },
        {
            target: ".class-sections-step",
            placement: "top",
            content: (
                <JoyrideContent
                    en="Enter number of section of each class."
                    hi="प्रत्येक कक्षा के अनुभागों की संख्या दर्ज करें।"
                />
            ),
            showNext: true,
        },
        {
            target: ".class-teacher-step",
            placement: "top",
            content: (
                <JoyrideContent
                    en="Assign class teachers for each section.."
                    hi="प्रत्येक सेक्शन के लिए कक्षा शिक्षक नियुक्त करें।"
                />
            ),
            showNext: true,
        },
        {
            target: ".add-edit-subject-step",
            placement: "top",
            content: (
                <JoyrideContent
                    en="Click here to add or edit subjects."
                    hi="विषयों को जोड़ने या संपादित करने के लिए यहाँ क्लिक करें।"
                />
            ),
            hideFooter: true,
        },
        {
            target: ".select-subjects-step",
            placement: "top",
            content: (
                <JoyrideContent
                    en="Select the subjects for this class."
                    hi="इस कक्षा के लिए विषयों का चुनाव करें ।"
                />
            ),
        },
        {
            target: ".subject-periods-step",
            placement: "top",
            content: (
                <JoyrideContent
                    en="Set max periods per week, theory, and practical classes."
                    hi="प्रति सप्ताह अधिकतम पीरियड, थ्योरी और प्रैक्टिकल क्लास सेट करें।"
                />
            ),
            showNext: true,
        },
        {
            target: "body", // center popup
            placement: "center",
            content: (
                <div style={{ textAlign: "center", minWidth: 280 }}>
                    <h6 style={{ marginBottom: 10 }}>
                        Do you want to add another subject?
                    </h6>

                    <div className="d-flex justify-content-center gap-3 mt-3">
                        <Button
                            size="sm"
                            variant="success"
                            onClick={() => {
                                dispatch(setStepIndex(5));
                            }}
                        >
                            Yes
                        </Button>

                        <Button
                            size="sm"
                            variant="secondary"
                            onClick={() => {
                                dispatch(setStepIndex(8));
                            }}
                        >
                            No
                        </Button>
                    </div>
                </div>
            ),
            disableBeacon: true,
            hideFooter: true,
            spotlightClicks: false,
        },
        {
            target: ".save-subject-config-step",
            placement: "top",
            content: (
                <JoyrideContent
                    en="click here to submit and save ."
                    hi="सबमिट और सेव करने के लिए यहां क्लिक करें ।"
                />
            ),
            disableBeacon: true,
            hideFooter: true,
        },
        {
            target: ".repeat-confirm-step",
            placement: "top",
            disableBeacon: true,
            disableOverlayClose: true,
            disableScrolling: true,
            floaterProps: {
                disableFlip: true,
                offset: 14,   // 🎯 outside top of table
            },
            content: (
                <JoyrideContent
                    en="Repeat this process for all classes."
                    hi="सभी कक्षाओं के लिए इस प्रक्रिया को दोहराएं।"
                />
            ),
            showNext: true,
        },
        {
            target: ".save-config-step",
            content: (
                <JoyrideContent
                    en="Click here to save your class configuration."
                    hi="कक्षा की सेटिंग सहेजने के लिए यहाँ क्लिक करें।"
                />
            ),
            placement: "top",
            disableBeacon: true,
            hideFooter: true,
        },
        {
            target: ".add-class-step",
            placement: "top",
            disableBeacon: true,
            hideFooter: true,   // hide Joyride footer
            showBackButton: false,
            content: (
                <div>
                    <JoyrideContent
                        en="Click here to add a new class if needed, or click Skip to proceed."
                        hi="यदि नई कक्षा जोड़नी हो तो यहाँ क्लिक करें, अन्यथा आगे बढ़ने के लिए Skip करें।"
                    />

                    {/* Custom footer */}
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "12px"
                    }}>
                        <button
                            style={{
                                background: "transparent",
                                border: "none",
                                color: "#2563eb",
                                cursor: "pointer",
                                fontWeight: 500
                            }}
                            onClick={() => {
                                // SKIP ACTION
                                navigate("/timetable/sections", {
                                    state: { startSectionTour: true },  // 👈 flag for sections tour
                                });
                            }}
                        >
                            Skip
                        </button>

                        <button
                            style={{
                                background: "#ec4899",
                                border: "none",
                                color: "white",
                                padding: "6px 14px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontWeight: 600
                            }}
                            onClick={() => {
                                // NEXT ACTION
                                setActiveTab("add");

                                const wait = setInterval(() => {
                                    const el = document.querySelector(".add-class-name-step");
                                    if (el) {
                                        clearInterval(wait);
                                        dispatch(setStepIndex(12)); // first add-class step index
                                        window.dispatchEvent(new Event("resize"));
                                    }
                                }, 100);
                            }}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )
        },
        {
            target: ".add-class-name-step",
            content: (   // ✅ FIXED (was ccontent)
                <JoyrideContent
                    en="Enter the class name."
                    hi="यहाँ कक्षा का नाम दर्ज करें।"
                />
            ),
            placement: "bottom",
            showNext: true,
        },
        {
            target: ".add-class-teacher-step",
            content: (
                <JoyrideContent
                    en="Assign class teachers for each section."
                    hi="प्रत्येक सेक्शन के लिए कक्षा शिक्षक नियुक्त करें।"
                />
            ),
            placement: "bottom",
            showNext: true,
        },
        {
            target: ".add-class-subject-step",
            content: (
                <JoyrideContent
                    en="Select the subjects for this class."
                    hi="इस कक्षा के लिए विषय चुनें।"
                />
            ),
            placement: "bottom",
        },
        {
            target: ".add-class-periods-step",
            content: (
                <JoyrideContent
                    en="Set periods, theory, and practical classes."
                    hi="पीरियड्स, थ्योरी और प्रैक्टिकल कक्षाएँ निर्धारित करें।"
                />
            ),
            placement: "bottom",
            showNext: true,
        },
        {
            target: ".add-class-submit-step",
            content: (
                <JoyrideContent
                    en="Click here to create the class."
                    hi="कक्षा बनाने के लिए यहाँ क्लिक करें।"
                />
            ),
            placement: "top",
            hideFooter: true,
        },
        {
            target: ".class-list-view-step",
            content: (
                <JoyrideContent
                    en="Click here to view all classes and their details at one place."
                    hi="सभी क्लास और उनकी डिटेल्स एक ही जगह देखने के लिए यहां क्लिक करें।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            spotlightClicks: true,
            hideFooter: true,
        },
    ];

export const sectionSteps = () => [
    {
        target: ".section-expand-step",
        placement: "right",
        disableBeacon: true,
        content: (
            <JoyrideContent
                en="Click here to view the list of subject teachers."
                hi="विषय शिक्षकों की सूची देखने के लिए यहां क्लिक करें।"
            />
        ),
        showNext: true,
        showSkip: true,
    },
    {
        target: ".subject-teacher-select-step",
        placement: "left",
        disableBeacon: true,
        content: (
            <JoyrideContent
                en="To change the assigned teacher click here and choose another teacher."
                hi="अगर आप असाइन किए गए शिक्षक को बदलना चाहते हैं तो यहां क्लिक करें और दूसरा शिक्षक चुनें।"
            />
        ),
        showNext: true,
        showSkip: true,
    },
    {
        target: ".update-teachers-step",
        placement: "top",
        disableBeacon: true,
        hideFooter: true,
        content: (
            <JoyrideContent
                en="Click on Update Teachers to save the changes."
                hi="बदलावों को सेव करने हेतु अपडेट टीचर्स पर क्लिक करें।"
            />
        ),
    },
];


export const periodSteps = ({
    setStepIndex,
    setShowFormModal,
    navigate,
    dispatch,                  // 👈 ADD

}) => [
        {
            target: ".create-period-step",
            content: (
                <JoyrideContent
                    en="Click here to create or edit periods."
                    hi="पीरियड बनाने या संपादित करने के लिए यहाँ क्लिक करें।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            spotlightClicks: true,
            hideFooter: true,

        },
        {
            target: ".num-period-step",
            content: (
                <JoyrideContent
                    en="Set how many periods your school has."
                    hi="स्कूल में कुल कितने पीरियड होंगे, यह निर्धारित करें।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            spotlightClicks: true,
            showNext: true,
        },
        {
            target: ".period-duration-step",
            content: (
                <JoyrideContent
                    en="Set each period duration."
                    hi="प्रत्येक पीरियड की अवधि तय करें।"
                />
            ),
            placement: "bottom",
            disableBeacon: true,
            spotlightClicks: true,
            showNext: true,
        },
        {
            target: ".breaks-step",
            content: (
                <JoyrideContent
                    en="Add breaks between periods."
                    hi="पीरियड्स के बीच ब्रेक जोड़ें।"
                />
            ),
            placement: "top",
            disableBeacon: true,
            spotlightClicks: true,
            showNext: true,
        },
        {
            target: ".submit-period-step",
            content: (
                <JoyrideContent
                    en="Save your final period setup."
                    hi="अंतिम पीरियड सेटअप को सहेजें।"
                />
            ),
            placement: "top",
            disableBeacon: true,
            spotlightClicks: true,
            hideFooter: true,

        },
    ];

export const generateTimetableSteps = () => [
    {
        target: ".tour-generate-timetable",
        placement: "bottom",
        disableBeacon: true,
        spotlightClicks: true,
        hideFooter: true,
        content: (
            <JoyrideContent
                en="Click on Generate Timetable to get the output."
                hi="आउटपुट पाने के लिए जनरेट टाइमटेबल पर क्लिक करें।"
            />
        ),
    },
    {
        target: ".timetable-generate",
        placement: "top",
        disableBeacon: true,
        showNext:true,
        content: (
            <JoyrideContent
                en="Timetable generated successfully."
                hi="टाइमटेबल सफलतापूर्वक जनरेट हो गया है।"
            />
        ),
    },
];

export const teacherTimetableSteps = () => [
    {
        target: ".teacher-select-step",          // 🔹 teacher dropdown/list
        placement: "bottom",
        disableBeacon: true,
        content: (
            <JoyrideContent
                en="Choose the teacher from list."
                hi="सूची में से शिक्षक चुनें"
            />
        ),
        hideFooter: true,
    },
];


export const substituteTeacherSteps = () => [
    {
        target: ".substitute-teacher-step",
        disableBeacon: true,
        content: (
            <JoyrideContent
                en="Click here to add substitution for absent teachers."
                hi="अनुपस्थित शिक्षकों के लिए विकल्प जोड़ने के लिए यहां क्लिक करें"
            />
        ),
        isFinalStep: true,
        placement: "top",
    },
];